module.exports = __webpack_public_path__ + "img/headLogo.d79552e4.png";